import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';
import LockButton from "../../buttons/LockButton";
import TableButton from "../../buttons/TableButton";
import DatabaseButton from "../../buttons/DatabaseButton";

const TextInput = ({
  onChange,
  onLock,
  textData,
  label,
  teacherMode,
  id,
  toggleTable,
  toggleDatabase,
  arity,
  domain,
  databaseEnabled,
  tableEnabled,
  errorProperty
}) => /*#__PURE__*/React.createElement(InputGroup, {
  size: "sm",
  className: "has-validation"
}, /*#__PURE__*/React.createElement(InputGroup.Prepend, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, label)), /*#__PURE__*/React.createElement(Form.Control, {
  isInvalid: errorProperty && errorProperty.length > 0,
  id: id,
  type: "text",
  onChange: e => onChange(e),
  value: textData.value,
  disabled: textData.locked
}), /*#__PURE__*/React.createElement(InputGroup.Append, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, "}")), toggleTable ? arity === 0 || arity > 2 || domain.size === 0 ? null : /*#__PURE__*/React.createElement(InputGroup.Append, null, /*#__PURE__*/React.createElement(TableButton, {
  onClick: () => toggleTable(),
  enabled: tableEnabled
})) : null, toggleDatabase ? arity < 1 || domain.size === 0 ? null : /*#__PURE__*/React.createElement(InputGroup.Append, null, /*#__PURE__*/React.createElement(DatabaseButton, {
  onClick: () => toggleDatabase(),
  enabled: databaseEnabled
})) : null, teacherMode ? /*#__PURE__*/React.createElement(LockButton, {
  lockFn: () => onLock(),
  locked: textData.locked
}) : null, /*#__PURE__*/React.createElement(Form.Control.Feedback, {
  type: "invalid"
}, errorProperty));

export default TextInput;